<template>
  <v-dialog
      v-model="showDialog"
      max-width="300px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Filter: Aufgaben</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-select
              :items="plannedSelects"
              label="Planungsstatus"
              v-model="filter.planned"
          ></v-select>
          <v-menu
              v-model="kostMigrMenu"
              :close-on-content-click="false"
              offset-y
          >
            <template #activator="data">
              <div v-on="data.on">
              <v-select
                  :items="bhStructurePlain"
                  label="Zuständigkeit"
                  v-model="filter.selectedKostMigr"
                  readonly
              ></v-select>
              </div>
            </template>

            <v-card style="max-height: 300px">
              <v-list>
                <v-list-group
                    v-for="(level1, j) in bhStructureLevel1"
                    :key="level1.value"
                    @click=""
                >
                  <template v-slot:activator>
                    <v-list-item-icon style="margin-right: 12px">
                      <v-btn
                          icon
                          :color="filter.selectedKostMigr === level1.value ? 'deep-purple accent-4' : 'dark-grey'"
                          @click.stop.prevent="filter.selectedKostMigr = level1.value; kostMigrMenu = false"
                      >
                        <v-icon v-text="filter.selectedKostMigr === level1.value ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'"></v-icon>
                      </v-btn>
                    </v-list-item-icon>
                    <v-list-item-title v-text="level1.text"></v-list-item-title>
                  </template>
                  <v-list-item-group
                      v-model="filter.selectedKostMigr"
                      single>
                    <v-list-item
                        v-for="(level2, i) in getBhStructureLevel2(level1.value)"
                        :key="level2.value"
                        :value="level2.value"
                        @click.capture.stop="filter.selectedKostMigr = level2.value; kostMigrMenu = false"
                        active-class="remove-background"
                    >
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                              :input-value="active"
                              color="deep-purple accent-4"
                              @click.capture.stop="filter.selectedKostMigr = level2.value; kostMigrMenu = false"
                          ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-text="level2.text"></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list-group>
              </v-list>
            </v-card>
          </v-menu>
          <v-select
              v-if="mode === 'tasks'"
              :items="taskTypes"
              label="Aufgabentyp"
              v-model="filter.taskType"
          ></v-select>
          <label class="v-label custom-label">Fälligkeit</label>
          <v-slider
              v-model="filter.timeInterval"
              :tick-labels="['0', '1', '2', '3', '4']"
              :max="4"
              :min="0"
              step="1"
              ticks="always"
              tick-size="4"
              :hint="'Wochen +/- um aktuellen Zeitraum'"

              persistent-hint
          ></v-slider>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
            :disabled="!canSubmit"
        >
          Anwenden
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import _orderBy from "lodash/orderBy"


export default {
  name: "QuickTaskDialog",
  props: {
    taskTypes: {
      type: Array,
      default: () => [],
    },
    bhStructure: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: "tasks",
    }
  },
  data () {
    return {
      showDialog: false,
      kostMigrMenu: false,
      plannedSelects: [{text: 'nicht relevant', value: "A"}, {text: 'beplant', value: "P"}, {text: 'unbeplant', value: "U"}],
      filter: {
        planned: "U", // null, true, false
        selectedKostMigr: "all", // all or id
        timeInterval: 1, // +- weeks to current date
        taskType: "all", // null, ab, bk, etc
      },
    }
  },
  computed: {
    canSubmit() {
      return true;
    },
    bhStructurePlain() {
      let res = [{text: "Alle", value: "all"}];
      this.bhStructure.forEach(bh => {
        res.push({text: bh.text, value: bh.id});
        bh.children.forEach(sub => {
          res.push({text: sub.text, value: sub.id});
        });
      });
      return res;
    },
    bhStructureLevel1() {
      let res =  _orderBy(this.bhStructure.map(bh => {
        return {text: bh.text, value: bh.id};
      }), 'text');
      res.unshift({text: "Alle", value: "all"});
      return res;
    },
  },
  watch: {

  },
  methods: {
    getBhStructureLevel2(id) {
      let res = [];
      this.bhStructure.forEach(bh => {
        if (bh.id === id) {
          bh.children.forEach(sub => {
            res.push({text: sub.text, value: sub.id});
          });
        }
      });
      return _orderBy(res, 'name');
    },
    show(filter) {
      if (this.showDialog) {
        return;
      }
      this.filter = {...filter};
      this.showDialog = true;
    },
    submit() {
      this.$emit('submit', this.filter);
      this.showDialog = false;
    },
  }
}
</script>

<style scoped>
::v-deep .blue-chips .theme--light.v-chip:not(.v-chip--active) {
  background-color: #1976D2;
  color: white;
}


::v-deep .v-list-group__header__prepend-icon {
  margin-right: 6px  !important;
  margin-top: 22px  !important;
}

::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 18px !important;
}

.remove-background {
  background-color: transparent !important;
}

::v-deep  .v-list-group__header {
  padding: 0 4px !important;
}

::v-deep .v-list-item__icon {
  margin: 8px 0;
}
::v-deep .v-list-item__action {
  margin: 8px 0;
}

::v-deep .v-input__slider .v-messages {
  margin: 8px 0;
}

.custom-label {
  max-width: 133%;
  transform: scale(0.75);
  transform-origin: left;
  pointer-events: auto;
  color: black; margin-left: 2px
}
</style>

